import ReadingEditor from './ReadingEditor';

export default ReadingEditor;
